export const STARTER_PROMPTS = [
  "Summarize the largest active risk exposures in my portfolio.",
  "Which positions drove my performance over the past month?",
  "Compare my portfolio's factor exposures with its benchmark.",
  "What are my largest position sizes right now?",
]
